
/* 项目统一配置文件*/


import xmGlobal from './application-prod'

export default xmGlobal